import React from "react";
import "./HealthOneServices.scss";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { Link } from "react-router-dom"; // ✅ Link import kiya

const HealthOneServices = () => {
  const { documents: categories, error } = useCollection("m_categories", [
    "status",
    "==",
    "active",
  ]);

  return (
    <section className="health-one-services-section">
      <div className="services-container">
        <div className="services-left">
          <h2 className="health-one-common-white-parent-heading">
            Our Services
          </h2>
          <p>
            At HealthOne Pharmacy, we prioritize your health and well‑being
            above all. Our services are designed to provide you with
            personalized care, expert advice, and easy access to the medications
            you need. Whether it's prescription refills, consultations with our
            experienced pharmacists, or guidance on wellness products, we're
            here to support you on your health journey. Trust us to be your
            reliable partner in maintaining a healthy lifestyle—because your
            health matters!
          </p>
          <button className="health-one-common-parent-btn">
            Explore All Our Services
          </button>
          <div className="arrow-right"></div>
        </div>

        <div className="services-right">
          {error && <p>Error: {error}</p>}
          {!categories && <p>Loading...</p>}

          {categories &&
            categories.slice(0, 6).map((service, index) => (
              <div className="service-card" key={service.id || index}>
                <img
                  src={service.categoryImgUrl}
                  alt={service.category}
                  className="icon"
                />

                {/* ✅ Category Name as Link */}
                <Link
                  to={`/products?category=${encodeURIComponent(service.category)}`}
                  className="category-link"
                >
                  <h3>{service.category}</h3>
                </Link>

                {service.subCategories && service.subCategories.length > 0 && (
                  <div className="tags">
                    {service.subCategories
                      .filter((sub) => sub.status === "active") // Sirf active wale
                      .map((sub, i) => (
                        <Link
                          to={`/products?category=${encodeURIComponent(service.category)}&subcategory=${encodeURIComponent(sub.subCategoryName)}`}
                          key={i}
                          className="tag"
                        >
                          <img
                            src={sub.subCategoryImgUrl}
                            alt={sub.subCategoryName}
                          />
                          {sub.subCategoryName}
                        </Link>
                      ))}
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default HealthOneServices;
